// Export the Component Definition for use in Contentful Studio
export {HeroBannerContentfulComponentDefinition} from './HeroBannerContentfulDefinition';
export {default} from './HeroBanner';
